import { mapGetters } from 'vuex';
import { getSearchViewType } from '../../../common/directives/_gtm.directive.js';

export default {
    name: 'searchSwitchView',
    inject: ['$eventBus'],
    methods: {
        onChangeViewStatus(view) {
            this.$eventBus.$emit('eventbus-showmap', view === 'map-view');
            this.$eventBus && this.$eventBus.$emit('ga', { ec: this.$options.name, en: 'click', el: view, pageData: { msp_view: getSearchViewType(view) } });
        },
    },
    computed: {
        ...mapGetters('msp', ['msp']),
    },
};
